module.exports = __webpack_public_path__ + "img/client-8.91ace436.png";